export default "__VITE_ASSET__OkF$oIM1__"